"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
exports[Symbol.toStringTag] = "Module";
var t = "https://docs.sanity.io/help/";

function r(e) {
  return t + e;
}

exports.generateHelpUrl = r;